import React from 'react';

function New(props) {
    return (
        <div>
            new

        </div>
    );
}

export default New;